import { useRef, useState } from 'react';

const TRAY = 192;
const COMMIT = 90;

export function SwipeRow({ children, tray, onSwipeRight, rightLabel, testId }) {
  const start = useRef(null);
  const moved = useRef(false);
  const [dx, setDx] = useState(0);
  const [open, setOpen] = useState(false);
  const [anim, setAnim] = useState(false);

  const onTouchStart = e => {
    const t = e.touches[0];
    start.current = { x: t.clientX, y: t.clientY, base: open ? -TRAY : 0, dir: null };
    moved.current = false;
    setAnim(false);
  };
  const onTouchMove = e => {
    const s = start.current;
    if (!s) return;
    const t = e.touches[0];
    const mx = t.clientX - s.x, my = t.clientY - s.y;
    if (!s.dir) {
      if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
      s.dir = Math.abs(mx) > Math.abs(my) ? 'h' : 'v';
    }
    if (s.dir !== 'h') return;
    moved.current = true;
    setDx(Math.max(-TRAY - 30, Math.min(140, s.base + mx)));
  };
  const onTouchEnd = () => {
    const s = start.current;
    start.current = null;
    if (!s || s.dir !== 'h') return;
    setAnim(true);
    if (dx > COMMIT && !open && onSwipeRight) { setDx(0); setOpen(false); onSwipeRight(); return; }
    const shouldOpen = dx < -60;
    setOpen(shouldOpen);
    setDx(shouldOpen ? -TRAY : 0);
  };
  const close = () => { setAnim(true); setOpen(false); setDx(0); };
  const onClickCapture = e => {
    if (moved.current || open) { e.stopPropagation(); e.preventDefault(); moved.current = false; if (open) close(); }
  };

  return (
    <div className="relative overflow-hidden" data-testid={testId}>
      <div className={`absolute inset-y-0 left-0 flex items-center gap-2 bg-emerald-600 px-4 text-sm font-semibold text-white transition-opacity ${dx > 20 ? 'opacity-100' : 'opacity-0'}`} style={{ width: Math.max(0, dx) + 40 }}>
        {dx > COMMIT ? '✓ ' : ''}{rightLabel}
      </div>
      <div className="absolute inset-y-0 right-0 flex" style={{ width: TRAY }} onClick={close}>{tray}</div>
      <div onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd} onClickCapture={onClickCapture}
        className={`relative bg-white touch-pan-y ${anim ? 'transition-transform duration-200 ease-out' : ''}`} style={{ transform: `translateX(${dx}px)` }}>
        {children}
      </div>
    </div>
  );
}
